import React, {useState, useEffect} from 'react'
import {useFirestore} from 'react-redux-firebase';
import {useDispatch, useSelector} from 'react-redux';
import {env} from '../../../constants/Environment';
import * as RouterActions from '../../../actions/RouterActions';
import * as StructureActions from '../../../actions/canvas/StructureActions';
import {EventRow} from './eventrow';
import { Table } from 'semantic-ui-react'

var moment = require('moment');
require('moment/locale/de');

export function EventlistByDate(props){
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const [events, setEvents] = useState([]);
    const [date, setDate] = useState(null);

    const existingStructure = useSelector(({canvas_structure}) => ({
            sport: Object.keys(canvas_structure.sport),
            category: Object.keys(canvas_structure.category),
            tournament: Object.keys(canvas_structure.tournament)
        }));

    useEffect(() => {
        if(typeof props.date === 'undefined' || !props.date.match(/^\d{4}\-\d{2}\-\d{2}$/)){
            setDate(moment().startOf('day').format('YYYY-MM-DD'));
        }else{
            setDate(props.date);
        }
    }, [props.date]);

    useEffect(() => {
        if(date === null)return;
        const dateStart = moment(date).startOf('day').toDate();
        const dateEnd = moment(date).endOf('day').toDate();

        const unsubscribe = firestore.collection('environments/' + env + '/canvas/' + props.channel + '/oe').where('active-to', '>=', dateStart).where('active-to', '<=', dateEnd).orderBy('active-to').onSnapshot((snapshot) => {
            const ev = [];

            snapshot.forEach(doc => {
                ev.push(doc.data());
            });
            setEvents(ev);
        });

        return unsubscribe;
    }, [date]);

    useEffect(() => {
        let needed = {
            sport: {},
            category: {},
            tournament: {}
        };

        events.forEach((ev) => {
            needed.sport[ev['sport-uid']] = true;
            needed.category[ev['category-uid']] = true;
            needed.tournament[ev['tournament-uid']] = true;
        })

        dispatch(StructureActions.load_missing(firestore, props.channel, 'sport', existingStructure.sport, Object.keys(needed.sport)));
        dispatch(StructureActions.load_missing(firestore, props.channel, 'category', existingStructure.category, Object.keys(needed.category)));
        dispatch(StructureActions.load_missing(firestore, props.channel, 'tournament', existingStructure.tournament, Object.keys(needed.tournament)));
    }, [events]);

    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Annahmeschluss</Table.HeaderCell>
                    <Table.HeaderCell>Plus</Table.HeaderCell>
                    <Table.HeaderCell>Kompakt</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Sport</Table.HeaderCell>
                    <Table.HeaderCell>Land</Table.HeaderCell>
                    <Table.HeaderCell>Wettbewerb</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
            {
                (events).map((event) => <EventRow key={event.uid} event={event} onClick={(e) => {
                    if(typeof props.onEventClick !== 'undefined')
                        props.onEventClick(event);
                }} />)
            }
            </Table.Body>
        </Table>
    );
}